var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28571 3H15.2143C16.3339 3 17.25 3.89063 17.25 5V6.228L19.5574 4.50208C19.9361 4.23998 20.4184 4.18238 20.845 4.33995L20.985 4.40046C21.4503 4.63237 21.7475 5.10285 21.75 5.625L21.75 14.3786C21.7475 14.8971 21.4503 15.3676 20.985 15.5995C20.5268 15.8279 19.9781 15.7891 19.5348 15.4816L17.25 13.771V15C17.25 16.0589 16.4153 16.9186 15.3656 16.9945L15.2143 17H12.6675L14.1821 20.3132L14.2182 20.4086C14.3252 20.7622 14.1571 21.1492 13.8118 21.3071C13.4351 21.4793 12.9901 21.3135 12.8179 20.9368L11.0182 17H7.9818L6.18211 20.9368C6.00989 21.3135 5.5649 21.4793 5.18818 21.3071C4.84286 21.1492 4.67478 20.7622 4.78181 20.4086L4.81789 20.3132L6.33249 17H4.28571C3.16608 17 2.25 16.1094 2.25 15V5C2.25 3.89063 3.16608 3 4.28571 3ZM11.516 15.5C11.5051 15.4998 11.4941 15.4998 11.4831 15.5H7.51693C7.50593 15.4998 7.49495 15.4998 7.48398 15.5H4.28571C3.98519 15.5 3.75 15.2713 3.75 15V5C3.75 4.72866 3.98519 4.5 4.28571 4.5H15.2143C15.5148 4.5 15.75 4.72866 15.75 5V7.72727L15.7571 7.83344C15.8322 8.38402 16.4841 8.6761 16.9495 8.32766L20.25 5.856V14.143L16.9495 11.6723C16.455 11.3021 15.75 11.655 15.75 12.2727V15C15.75 15.2713 15.5148 15.5 15.2143 15.5H11.516Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 12.25C10.9142 12.25 11.25 11.9142 11.25 11.5C11.25 11.1203 10.9678 10.8065 10.6018 10.7568L10.5 10.75H6.5C6.08579 10.75 5.75 11.0858 5.75 11.5C5.75 11.8797 6.03215 12.1935 6.39823 12.2432L6.5 12.25H10.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 9.25C12.9142 9.25 13.25 8.91421 13.25 8.5C13.25 8.1203 12.9678 7.80651 12.6018 7.75685L12.5 7.75H6.5C6.08579 7.75 5.75 8.08579 5.75 8.5C5.75 8.8797 6.03215 9.19349 6.39823 9.24315L6.5 9.25H12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamHover);
export default __webpack_public_path__ + "static/media/camHover.24afe618f542d4eb473464aabf5005f3.svg";
export { ForwardRef as ReactComponent };